import { FC, useRef, useState } from 'react';
import { ViewDetailsButton } from '@pages/invoice-generator/shared/ui/ViewDetailsButton';
import { MdExpandMore } from 'react-icons/md';
import { IFailedRecord } from '../../types';
import classes from './ExpandableListItem.tailwind';

export const ExpandableListItem: FC<IFailedRecord> = ({ source, messages, ...rest }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const detailsRef = useRef<HTMLDivElement>(null);

  return (
    <li {...rest}>
      <ViewDetailsButton
        title={source}
        onClick={() => setIsExpanded(!isExpanded)}
        Icon={
          <MdExpandMore
            style={{
              transform: `rotate(${isExpanded ? 0 : -90}deg)`,
            }}
            className={classes.buttonStyle}
          />
        }
        data-id="view-details-button"
      />
      <div
        ref={detailsRef}
        style={
          isExpanded
            ? {
                height: detailsRef.current?.scrollHeight + 'px',
              }
            : {
                height: '0px',
              }
        }
        className={classes.listItemDataContainerAnimation}
      >
        <div className={classes.listItemDataContainer}>
          {messages.map(errorMessage => (
            <p data-id="error-message" className={classes.textStyle} key={errorMessage}>
              <strong className={classes.titleColor}>Error:</strong> {errorMessage}
            </p>
          ))}
        </div>
      </div>
    </li>
  );
};
